import { createTheme } from "@mui/material/styles";

export const appColors = {
  brandOrange: "#f89a31",
  brandOrangeDark: "#d97812",
  brandOrangeLight: "#ffb15d",
  brandSoft: "#fff4e8",
  brandLine: "#ffd9ad",
  charcoal: "#3b3734",
  charcoalLight: "#5a514b",
  textMuted: "#7b6250",
  divider: "#ece7e2",
  white: "#ffffff",
};

export const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: appColors.brandOrange,
      light: appColors.brandOrangeLight,
      dark: appColors.brandOrangeDark,
      contrastText: appColors.white,
    },
    secondary: {
      main: appColors.charcoal,
      light: appColors.charcoalLight,
      dark: "#241f1c",
      contrastText: appColors.white,
    },
    background: {
      default: appColors.white,
      paper: appColors.white,
    },
    text: {
      primary: appColors.charcoal,
      secondary: appColors.textMuted,
    },
    divider: appColors.divider,
  },
  typography: {
    fontSize: 13,
    h4: { fontSize: "1.75rem" },
    h5: { fontSize: "1.35rem" },
    h6: { fontSize: "1.1rem" },
    button: { textTransform: "none" },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "0.8125rem",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: appColors.white,
          color: appColors.charcoal,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: appColors.brandSoft,
          color: appColors.charcoal,
          fontSize: "0.78rem",
          fontWeight: 800,
          lineHeight: 1.2,
          borderBottom: `2px solid ${appColors.brandLine}`,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: appColors.brandSoft,
        },
      },
    },
  },
});

export const tableHeaderStyles = {
  backgroundColor: appColors.brandSoft,
  color: appColors.charcoal,
  fontSize: "0.78rem",
  fontWeight: 800,
  borderColor: appColors.brandLine,
};

export const dataGridStyles = {
  root: {
    borderColor: appColors.divider,
    color: appColors.charcoal,
    fontSize: "0.8125rem",
  },
  columnHeaders: {
    backgroundColor: appColors.brandSoft,
    borderBottom: `2px solid ${appColors.brandLine}`,
    color: appColors.charcoal,
    minHeight: "42px !important",
  },
  columnHeader: {
    backgroundColor: appColors.brandSoft,
    "&:focus, &:focus-within": {
      outline: "none",
    },
  },
  columnHeaderTitle: {
    fontSize: "0.78rem",
    fontWeight: 800,
    lineHeight: 1.2,
  },
  iconSeparator: {
    color: appColors.brandLine,
  },
  sortIcon: {
    color: appColors.brandOrangeDark,
  },
  menuIconButton: {
    color: appColors.textMuted,
  },
};

export const layoutStyles = {
  appBackground: {
    minHeight: "100vh",
    bgcolor: appColors.white,
  },
  mainContainer: {
    pb: 4,
    bgcolor: appColors.white,
  },
  mainPanel: {
    mt: 3,
    p: 3,
    backgroundColor: appColors.white,
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 2,
  },
};

export const menuStyles = {
  item: {
    borderRadius: 1.5,
    minHeight: 44,
    color: appColors.charcoal,
    "& .MuiListItemIcon-root": {
      color: appColors.textMuted,
    },
    "&:hover": {
      bgcolor: "rgba(248, 154, 49, 0.12)",
      "& .MuiListItemIcon-root": {
        color: appColors.brandOrangeDark,
      },
    },
    "&.Mui-selected": {
      bgcolor: "rgba(248, 154, 49, 0.18)",
      color: appColors.charcoal,
      boxShadow: `inset 3px 0 0 ${appColors.brandOrange}`,
      "& .MuiListItemIcon-root": {
        color: appColors.brandOrangeDark,
      },
      "&:hover": {
        bgcolor: "rgba(248, 154, 49, 0.24)",
      },
    },
  },
  subItem: {
    ml: 1,
    borderRadius: 1.5,
    minHeight: 38,
    color: appColors.charcoal,
    "&:hover": { bgcolor: "rgba(248, 154, 49, 0.1)" },
    "&.Mui-selected": {
      bgcolor: appColors.brandSoft,
      color: appColors.brandOrangeDark,
      fontWeight: 700,
      "&:hover": { bgcolor: "rgba(248, 154, 49, 0.18)" },
    },
  },
};
